module.exports = __webpack_public_path__ + "static/34-fd3081c6c60cceccf9d1decadf7ec1fa.jpg";